import React from 'react';
import styled from 'styled-components';

import { Spacer } from 'src/packages/core';
import { useTheme } from 'src/packages/theme';
import { CardProps } from './Card.types';
import { ThemeProvider } from 'src/packages/theme';
import { isFalsy } from 'src/utils/is-falsy';

const StyledCard = styled((props) => <Spacer {...props} />)<CardProps>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) =>
    props.alignItems === 'center' ? props.alignItems : props.theme.rtl ? 'flex-end' : 'flex-start'};
  justify-content: ${(props) => props.justifyContent};
  color: ${(props) => props.theme.colors.text.primary};
  border: ${(props) =>
    props.border || (props.outline && `1px solid ${props.theme.colors.border.lighter}`) || ''};
  border-radius: ${(props) => props.borderRadius};
  background: ${(props) => props.backgroundColor ?? props.theme.colors.background.secondary.BG1};
`;

const Card: React.FC<CardProps> = (props: CardProps) => {
  const contextTheme = useTheme();

  const {
    alignItems = 'flex-start',
    justifyContent = 'flex-start',
    border,
    borderRadius = '8px',
    height = 'fit-content',
    theme,
    children,
    outline = true,
    ...rest
  } = props;

  return (
    <ThemeProvider theme={theme} rtl={contextTheme.rtl}>
      <StyledCard
        {...rest}
        border={border}
        outline={outline}
        borderRadius={borderRadius}
        alignItems={alignItems}
        justifyContent={justifyContent}
        px={!isFalsy(rest.p) ? rest.p : !isFalsy(rest.px) ? rest.px : [3, 6]}
        py={!isFalsy(rest.p) ? rest.p : !isFalsy(rest.py) ? rest.px : [3, 8]}
        height={height}
      >
        {children}
      </StyledCard>
    </ThemeProvider>
  );
};

export default Card;
